export const DROPDOWN_CODES = {
  Gender: "Gender",
  Relationship: "Relationship",
  AddressType: "AddressType",
  CourseLevel: "CourseLevel",
  Semester: "Semester",
  Grade: "Grade",
  OrgType: "OrgType",
  InternshipFeeType: "InternshipFeeType",
  Visibility: "Visibility",
  ApplicationStatus: "ApplicationStatus",
  InternshipStatus: "InternshipStatus",
  Course: "Course",
  Specialization: "Specialization",
  WorkType: "WorkType",
  WorkMode: "WorkMode",
  InternshipBenefits: "InternshipBenefits",
  AccommodationType: "AccommodationType",
  TransportationType: "TransportationType",
  BusinessType: "BusinessType",
  // New constants for skills
  Skill: "Skill",
  ProficiencyLevel: "ProficiencyLevel",
  IndustryType: "IndustryType",
  // New constant for employment type
  EmploymentType: "EmploymentType",
  InternshipType: "InternshipType",
  DocumentType: "DocumentType",
  DocumentName: "DocumentName",
  StudentStatus: "StudentStatus",
  CompletionYear: "CompletionYear",
  GraduationYear: "GraduationYear",
  MentorShipMode: "ModeOfConnect",
  DurationMode: "perSessionDuration",
  GrpSizeMode: "maxAttendeesPerSession",
  SessionCode: "sessionsRequired",
  SubjectCode: "subject",
  SubjectSyllabus: "subjectSyllabus",
  MentorshipRole: "mentorshipForRole",
  Language: "sessionConductedInLanguages",
  ContactCategory: "ContactCategory",
  ContactSubCategory: "ContactSubCategory",
  PaymentMethod: "paymentmethod",
  PaymentBankDetails: "PaymentBankDetails",
  SubscriptionCancellationReason: "SubscriptionCancellationReason",
};
